<mat-card *ngIf="editInsuranceData" class="insurance-card">
  <form #insuranceForm="ngForm">

    <mat-toolbar class="insurance-toolbar">
      <span style="width:90%">Insurance details</span>
      <span class="fill-remaining-space"></span>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="desar()" matTooltip="Desar" [disabled]="!insuranceForm.form.valid">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Tancar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <div class="insurance-content">

      <div class="insurance-form">

        <mat-form-field appearance="outline">
          <mat-label>Plate</mat-label>
          <input
            matInput
            name="plate"
            [(ngModel)]="editInsuranceData.plate"
            [matAutocomplete]="autoPlate"
            required>
        </mat-form-field>
        <mat-autocomplete #autoPlate="matAutocomplete">
          <mat-option *ngFor="let item of plateList" [value]="item.value">
            {{ item.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Policy Number</mat-label>
          <input
            matInput
            name="policy_number"
            [(ngModel)]="editInsuranceData.policy_number"
            [matAutocomplete]="autoPolicyNumber"
            required>
        </mat-form-field>
        <mat-autocomplete #autoPolicyNumber="matAutocomplete">
          <mat-option *ngFor="let item of policyNumberList" [value]="item.value">
            {{ item.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Insurance Company</mat-label>
          <input
            matInput
            name="company"
            [(ngModel)]="editInsuranceData.company"
            [matAutocomplete]="autoCompany"
            required>
        </mat-form-field>
        <mat-autocomplete #autoCompany="matAutocomplete">
          <mat-option *ngFor="let item of companyList" [value]="item.value">
            {{ item.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Owner Name</mat-label>
          <input
            matInput
            name="name"
            [(ngModel)]="editInsuranceData.name"
            [matAutocomplete]="autoName"
            required>
        </mat-form-field>
        <mat-autocomplete #autoName="matAutocomplete">
          <mat-option *ngFor="let item of nameList" [value]="item.value">
            {{ item.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Policy Start Date</mat-label>
          <input matInput type="date" name="policy_start_date" [(ngModel)]="editInsuranceData.policy_start_date">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Policy Expiry Date</mat-label>
          <input matInput type="date" name="policy_expiry_date" [(ngModel)]="editInsuranceData.policy_expiry_date">
        </mat-form-field>

      </div>

      <div class="insurance-preview">
        <img src="assets/imatges/grenada_insurance.png" alt="Insurance">
        <h3>{{ editInsuranceData.policy_number || 'WITHOUT POLICY NUMBER' }}</h3>
        <p>**Company:** {{ editInsuranceData.company || '—' }}</p>
        <p>**Owner:** {{ editInsuranceData.name || '—' }}</p>
        <p>**Plate:** {{ editInsuranceData.plate || '—' }}</p>
        <p>**Expiry date:** {{ editInsuranceData.policy_expiry_date || '—' }}</p>
      </div>

    </div>

  </form>
</mat-card>